import React from "react";
import store from './Stores/SurveyStore'
import { observer } from "mobx-react";
import SurveyTitleArea from "./SurveyTitleArea";
import SurveySection from "./SurveySection";
import SurveyPage from "./SurveyPage";
import SurveyContentContainer from "./SurveyContentContainer";
import { toJS } from "mobx";



const ErrorSummaryDetailed = observer((props) => {
    const renderErrorWarningLists = (pageName) => {
        try {

            var listWarningsForPage;
            var listErrorsForPage;
            //<span>{" -> " + error.ErrorTypeID}</span>
            var pageNameTrim = pageName.toLowerCase().replace(/\s+/g, '');

            if (pageNameTrim != "home") {

                listWarningsForPage =
                    store.allValidationErrorsList[pageNameTrim].map((error) => {
                        if (error.ErrorTypeID == 1 || error.ErrorTypeID == 2) {
                            return (<li><b>{error.QuestionName}: </b>
                                {error.ErrorMessage}
                                {error.ErrorExplanation &&
                                    <React.Fragment>
                                        <i> Explanation:</i>
                                        <span style={{ color: '#3d9221' }}> {error.ErrorExplanation}</span>
                                    </React.Fragment>
                                }
                            </li>);
                        } else {
                            return null;
                        }
                    }
                    )

                listErrorsForPage =
                    store.allValidationErrorsList[pageNameTrim].map(error => {
                        if (error.ErrorTypeID == 0) {
                            return <li>test</li>
                        } else {
                            return null;
                        }
                    }
                )

                var emptyListErrors = listErrorsForPage.every(element => element === null);
                var emptyListWarnings = listWarningsForPage.every(element => element === null);
                return (<SurveySection labelText={pageName}><div>
                    {!emptyListWarnings && <h6 style={{ color: '#dab751' }}>Unusual items</h6>}
                    <ul>{listWarningsForPage}</ul>
                </div>
                    <div>{!emptyListErrors && <h6 style={{ color: '#da5151' }}>Critical items</h6>}<ul>{listErrorsForPage}</ul></div>
                </SurveySection>)
            }
            return null;




        } catch (e) {
            console.log("Cannot render list. See error.", e)
        }
    }

    return (
        <React.Fragment>
            <SurveyTitleArea labelText="Error Summary" />
            <SurveyContentContainer>
                {store.allValidationErrorsList && store.availPageTitles.map((pageName) =>
                    renderErrorWarningLists(pageName))}
            </SurveyContentContainer>
        </React.Fragment>
    );
});
export default ErrorSummaryDetailed;
